module.exports = __webpack_public_path__ + "static/img/2_1_2.a14956ce.jpg";